module.exports = __webpack_public_path__ + "img/request.945801ac.png";